import React from 'react';

const QuantityEditor: React.FC = () => {
    return <></>;
};

export default QuantityEditor;
